import Alt from "alt";

const alt = new Alt();

if (process.env.NODE_ENV !== "production") {
    try {
        Alt.debug("RTM", alt, window.parent);
    } catch (exception) {
        console.error(exception); // eslint-disable-line no-console
    }
}

export default alt;
